module.exports = __webpack_public_path__ + "img/yl.89f79e5d.png";